import React, { ReactNode } from 'react';
import Shared, { IProps as SharedProps } from '../shared';
import { Flex, Container, LargeDesktopOnly } from './with-sidebar.styles';

type Props = {
  top: ReactNode;
  main: ReactNode;
  sidebar: ReactNode;
  hideSidebarOnMobile?: boolean;
} & SharedProps;

const LayoutWithSidebar: React.FC<Props> = ({
  location,
  top,
  main,
  sidebar,
  children,
  hideSidebarOnMobile = false,
}) => (
  <Shared location={location}>
    <Container>
      {top}
      <Flex>
        {main}
        {hideSidebarOnMobile
          ? <LargeDesktopOnly>{sidebar}</LargeDesktopOnly>
          : sidebar}
      </Flex>
    </Container>
    {children}
  </Shared>
);

export default LayoutWithSidebar;
